import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

/**
 * Workspace nhiều tab (docs/upgrade/06): một mục menu mở một màn, các màn cùng đối tượng là tab.
 * Tab chọn bằng `?view=` vì nhiều màn bên trong đã dùng `?tab=` cho tab của chính chúng.
 */
export const WORKSPACE_VIEW_QUERY = 'view'

export interface WorkspaceTab {
  key: string
  labelKey: string
  icon?: string
  permission?: string | string[]
  permissionMode?: 'any' | 'all'
  component: () => Promise<Component | { default: Component }>
  props?: Record<string, unknown>
}

export interface WorkspaceDefinition {
  tabs: WorkspaceTab[]
}

/**
 * Quyền vào workspace = có quyền ít nhất một tab; từng tab vẫn tự kiểm quyền riêng.
 * `undefined` khi có tab mở cho mọi tài khoản đăng nhập (vd. Đơn từ, Lịch làm việc) — workspace khi đó không chặn.
 */
export function workspacePermissions(definition: WorkspaceDefinition): string[] | undefined {
  if (definition.tabs.some(tab => tab.permission === undefined)) return undefined
  return [...new Set(definition.tabs.flatMap(tab => Array.isArray(tab.permission) ? tab.permission : [tab.permission!]))]
}

export function workspaceRoute(path: string, name: string, breadcrumb: string[], definition: WorkspaceDefinition): RouteRecordRaw {
  const permission = workspacePermissions(definition)
  return {
    path,
    name,
    component: () => import('../components/WorkspaceView.vue'),
    meta: { breadcrumb, workspace: definition, ...(permission?.length ? { permission, permissionMode: 'any' as const } : {}) },
  }
}

/** Route cũ chuyển sang tab của workspace, giữ nguyên query (vd. `?request=`, `?id=`) để deep-link cũ vẫn mở đúng bản ghi. */
export function workspaceRedirect(path: string, name: string, workspacePath: string, view: string): RouteRecordRaw {
  return { path, name, redirect: to => ({ path: workspacePath, query: { ...to.query, [WORKSPACE_VIEW_QUERY]: view } }) }
}
